import classNames from "classnames";
import { FC, ReactNode } from "react";
import Text from "~/components/Text";
import { isUsingLayoutV2 } from "~/utils/theme";

interface VariantItemProps {
  title?: string;
  children?: ReactNode;
  extra?: ReactNode;
  value?: any;
}

const VariantItem: FC<VariantItemProps> = ({
  title,
  children,
  extra,
  value,
}) => {
  return (
    <div className="flex flex-col gap-1">
      <div
        className={classNames("flex items-center justify-between", {
          "!justify-start gap-10": isUsingLayoutV2,
        })}
      >
        <div className="flex gap-2">
          <Text type="body-1" className="font-semibold">
            {title}:
          </Text>
          <Text type="body-1" className="text-gray-500">
            {value}
          </Text>
        </div>
        {isUsingLayoutV2 && title === "Size" && (
          <Text type="label-1" className="!font-thin">
            |
          </Text>
        )}
        {extra}
      </div>
      {children}
    </div>
  );
};

export default VariantItem;
